import React from 'react';
import {
  Grid,
  Skeleton as ComponentSkeleton,
} from '@nextiva/next-ui-components';

export const Skeleton = () => {
  return (
    <Grid container spacing={1} style={{ marginTop: 16 }}>
      <Grid item xs={6}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={6} />
      <Grid item xs={6}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={6} />
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3} />
      <Grid item xs={6}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={6} />
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={9} />
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={3}>
        <div className="grid-item-shadow" />
      </Grid>
      <Grid item xs={6} />
    </Grid>
  );
};
export const SkeletonAllRows = () => {
  return (
    <Grid container spacing={1} mt={2}>
      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((row) => (
        <Grid item xs={12} key={row}>
          <ComponentSkeleton
            borderRadius="10px"
            height={row === 1 ? '24px' : '60px'}
            variant="rectangular"
          />
        </Grid>
      ))}
    </Grid>
  );
};
